import {
    URLAPI,
    MAINTENANCE_SURVEY_RESULTS_CREATE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _create_maintenance_survey_results: {
        data: {},
        status: 0,
        message: {},
    },
};

export const CREATE_MAINTENANCE_SURVEY_RESULTS = "CREATE_MAINTENANCE_SURVEY_RESULTS";

export const maintenance_survey_results_module = (state = init, action) => {
    switch (action.type) {
        case CREATE_MAINTENANCE_SURVEY_RESULTS:
            return {
                ...state,
                _create_maintenance_survey_results: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const createMaintenanceSurveyResults = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${MAINTENANCE_SURVEY_RESULTS_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_MAINTENANCE_SURVEY_RESULTS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_MAINTENANCE_SURVEY_RESULTS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_MAINTENANCE_SURVEY_RESULTS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_maintenance_survey_results = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
